import { Injectable } from '@angular/core';
import { MenuService } from 'merlin-library';
import { LocalizationService } from 'src/core/utilitites/localization.service';

@Injectable({
  providedIn: 'root',
})
export class SubMenuService {
    private patientId;

  constructor(
      private menuService: MenuService,
      private localizationService: LocalizationService
      ) { }



  generateMenu(isIcmDevice, patientId, isActivatorClinic: boolean = false, isDtvForICM:boolean = false, rpCapableFlg, isLPDevice: boolean = false) {
    if(patientId != null){
        this.patientId = patientId;
    }

    const subMenuData = [
        {
            url: '/patient-list/patient-profile/patient-&-device-data/' + this.patientId,
            link: this.localizationService.generateLocalizedStr('label.gb.pat_prof'),
        }
    ];

    if (!isActivatorClinic) {
        subMenuData.push(
            {
                url: '/patient-list/transmission',
                link: this.localizationService.generateLocalizedStr('label.gb.transmission'),
            },
            {
                url: '/patient-list/all-transmissions',
                link: this.localizationService.generateLocalizedStr('label.gb.all_transmissions'),
            }
        );

        if ((isDtvForICM || !isIcmDevice) && !isLPDevice) {
            subMenuData.push({
                url: '/patient-list/dtv/' + this.patientId,
                link: this.localizationService.generateLocalizedStr('label.gb.patient_history_viewer'),
            });
        }

        if (isIcmDevice) {
            subMenuData.push({
                url: '/patient-list/view-snapshot',
                link: this.localizationService.generateLocalizedStr('label.gb.MSR_page_title'),
            });
        }

        if (rpCapableFlg) {
            subMenuData.push({
                url: '/patient-list/remote-programming' ,
                link: this.localizationService.generateLocalizedStr(
                    'label.gb.remote_programming'
                ),
            },)

        }

        subMenuData.push({
            url: '/patient-list/clinical-comment',
            link: this.localizationService.generateLocalizedStr('label.gb.clinical_comments'),
        });
    }
    this.menuService.setSubMenu(subMenuData);
  }

}
